{
  "info": "Informácie",
  "negative": "Chyba",
  "positive": "Úspech"
}
